export interface TaskFiltersDashboardState {
  agencyIds?: string[]
  assignedToUserIds?: string[]
}

export const defaultFilterState: TaskFiltersDashboardState = {
  agencyIds: undefined,
  assignedToUserIds: undefined,
}

const taskDashboardFiltersKey = 'taskDashboardFilters'

export const storeDashboardFilterState = (filters: TaskFiltersDashboardState) => {
  try {
    localStorage.setItem(taskDashboardFiltersKey, JSON.stringify(filters))
  } catch {
    // Optionally handle storage errors
  }
}

export const createInitialDashboardFilterState =
  (): TaskFiltersDashboardState => {
    try {
      const storedFilterState = localStorage.getItem(taskDashboardFiltersKey)

      if (!storedFilterState) return defaultFilterState

      const parsed = JSON.parse(storedFilterState) as TaskFiltersDashboardState

      if (!parsed) return defaultFilterState

      const assignedToUserIds =
        parsed.assignedToUserIds ?? defaultFilterState.assignedToUserIds

      const agencyIds = parsed.agencyIds ?? defaultFilterState.agencyIds

      return {
        ...defaultFilterState,
        assignedToUserIds: assignedToUserIds,
        agencyIds: agencyIds,
      }
    } catch {
      return defaultFilterState
    }
  }
